import {
  Spacing
} from 'UI'

export default theme => ({
  popup: {
    padding: () => window?.devicePixelRatio >= 1.5 ? Spacing(4) : Spacing(7, 0, 0, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    background: `${theme.primary[900]}C7`,
    zIndex: 999999
  },
  innerPopUp: {
    aspectRatio: '11 / 9'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: () => Spacing(0, 0, 4, 0)
  },
  icons: {
    color: theme.secondary[0],
    fontSize: 16
  },
  rateStarsClass: {
    marginLeft: 8 + 'px !important'
  },
  closeIcons: {
    color: theme.neutral[100],
    cursor: 'pointer'
  },
  priceAndCurrency: {
    alignItems: 'baseline'
  },
  priceAndCurrencyDiscount: {
    alignItems: 'baseline',
    opacity: 0.7,
    textDecoration: 'line-through !important'
  },
  infosAndButton: {
    background: theme.neutral[400],
    display: 'flex',
    justifyContent: 'space-between',
    padding: () => Spacing(5),
    margin: () => Spacing(0, 0, 4, 0),
    overflow: 'hidden'
  },
  infos: {
    display: 'flex',
    alignItems: 'center'
  },
  button: {
    width: '30%'
  },
  videoAndTableOfContents: {
    height: '70%',
    width: '100%',
    background: theme.neutral[400],
    border: 0 + ' !important'
  },
  tableOfContents: {
    width: '30%',
    height: '100%',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 8
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 4
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.primary[1300],
      borderRadius: 10
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.primary[1200]
    }
  },
  videoAndSubInfos: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  subInfos: {
    padding: () => Spacing(4),
    display: 'flex',
    gap: 8
  },
  socialMedia: {
    width: '100%',
    margin: () => Spacing(4, 0, 0, 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  video: {
    aspectRatio: '16 / 9'
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'baseline'
  }
})
